module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin": "0 auto",
      "width": "0px",
      "height": "0px",
      "overflow": "hidden"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./image/0.jpeg"),
      "width": "700"
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "pc_device",
    attrs: {
      "id": "activity-detail"
    }
  }, [_c('div', {
    staticClass: "page-bizinfo"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', {
    attrs: {
      "id": "activity-name"
    }
  }, [_vm._v("如何确认WiFi已被分享")])])]), _vm._v(" "), _c('div', {
    staticClass: "page-content",
    attrs: {
      "id": "page-content"
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('strong', [_vm._v("一、请确认WiFi已分享，即WiFi带有蓝色小钥匙。")])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("./image/0.jpeg")
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("如果WiFi尚未被分享，可以点击这个WiFi，在底部弹窗点击“分享热点”。")])])]), _vm._v(" "), _c('p', [_c('strong', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("分享热点提交信息后，请完全退出WiFi万能钥匙，然后过几分钟重新打开，查看是否是在分享的状态。")])])]), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": require("./image/1.jpeg")
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a497e33a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/docs/isShare.vue
// module id = 842
// module chunks = 1